import {
  BadgeCounterType,
  DrawMethod,
  ProjectCode,
  RaffleInstantType,
  RaffleInstantTypeText,
  TicketCardStyle
} from '@core/models';

export const getBadgeCounterType = (
  raffleInstantType: RaffleInstantType
): BadgeCounterType => {
  switch (raffleInstantType) {
    case RaffleInstantType.Regular:
      return BadgeCounterType.Default;
    default:
      return BadgeCounterType.Scratch;
  }
};

export const getInstantWinType = (
  raffleInstantType: RaffleInstantType
): TicketCardStyle => {
  switch (raffleInstantType) {
    case RaffleInstantType.Scratch:
      return TicketCardStyle.Scratch;
    case RaffleInstantType.Flip:
      return TicketCardStyle.Flip;
    case RaffleInstantType.Spin:
      return TicketCardStyle.Spin;
    default:
      return TicketCardStyle.Default;
  }
};

export const getInstantTypeText = (
  raffleInstantType: RaffleInstantType
): RaffleInstantTypeText => {
  switch (raffleInstantType) {
    case RaffleInstantType.Scratch:
      return RaffleInstantTypeText.Scratch;
    case RaffleInstantType.Flip:
      return RaffleInstantTypeText.Flip;
    case RaffleInstantType.Spin:
      return RaffleInstantTypeText.Spin;
    default:
      return RaffleInstantTypeText.Regular;
  }
};

export const getLogoText = (raffleInstantType: RaffleInstantType): string[] => {
  switch (raffleInstantType) {
    case RaffleInstantType.Scratch:
      return ['tap', 'to', 'scratch'];
    case RaffleInstantType.Flip:
      return ['tap', 'to', 'flip'];
    case RaffleInstantType.Spin:
      return ['tap', 'to', 'spin'];
    default:
      return [];
  }
};

export const getDrawMethod = (method: DrawMethod): string =>
  `${method === DrawMethod.Auto ? 'Automated' : 'Live'} Draw`;

export const getDiscountedPrice = (
  quantity: number,
  price: number,
  discount: number
): number => {
  const originalPrice = quantity * price;

  return originalPrice - (originalPrice * discount) / 100;
};

export const getCompetitionPath = (
  projectCode: ProjectCode,
  slug: string
): string =>
  slug
    ? `/${projectCode === ProjectCode.SevenDays ? 'product' : 'competition'}/${slug}`
    : '/';
